export const isSomeFieldsTruthy = (ob) =>
  !!Object.keys(ob).find((key) => ob[key]);
